module.exports = __webpack_public_path__ + "static/img/banner.67d105b9.jpg";